export default function () {
  // 个人-身份证信息
  const IDCardList = [
    { key: 'idCardUrl', name: '身份证人像面（照片）' },
    { key: 'idCardBackUrl', name: '身份证国徽面（照片）' },
    { key: 'idCardNo', name: '身份证号' },
    { key: 'idCardValidDate', name: '身份证有效截止日期' },
  ]
  // 个人-驾驶证信息
  const personalDriversLicenseList = [
    { key: 'driverLicenceUrl', name: '驾驶证正页（照片）' },
    { key: 'driverLicenceBackUrl', name: '驾驶证副页（照片）' },
    { key: 'driverLicenceNo', name: '驾驶证证号' },
    { key: 'driverLicenceFilesNo', name: '驾驶证档案编号' },
    { key: 'driverLicenceCarModel', name: '准驾车型' },
    { key: 'driverLicenceFirstDate', name: '驾驶证初次领证日期' },
    { key: 'driverLicenceValidDate', name: '驾驶证有效截止日期' },
  ]
  // 个人-网约人证信息
  const personalHailingLicenceList = [
    { key: 'hailingLicenceUrl', name: '网约车驾驶员证（照片）' },
    { key: 'hailingLicenceCertificateNo', name: '网约车驾驶员资格证号' },
    { key: 'hailingLicenceCertificateFirstDate', name: '网约车驾驶员证初次领证日期' },
    { key: 'hailingLicenceCertificateStartDate', name: '网约车驾驶员证有效起始日期' },
    { key: 'hailingLicenceValidDate', name: '网约车驾驶员证有效截止日期' },
  ]
  return {
    IDCardList,
    personalDriversLicenseList,
    personalHailingLicenceList,
  }
}
